var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-6"},[_c('table-users-log',{attrs:{"current_page":_vm.current_page,"pageCount":_vm.pageCount,"title":`Derniers Utilisateurs connectés`,"data":_vm.users_connected,"loading":_vm.loading,"items-per-page":_vm.itemsPerPage},on:{"paginate":_vm.getUsersConnectedToday}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }